import { IStore } from '../../store';
import { TCRBActions } from './actions';
import { IAuthActions } from '../auth/actions';
import createMiddleware from '../../_core/create-middleware';
import crbHistoryMiddleware from './middlewares/history.middleware';

const crbBaseMiddleware = createMiddleware<IStore, TCRBActions | IAuthActions>()
    .getMiddleware();

const crbMiddlewares = [
    crbBaseMiddleware,
    crbHistoryMiddleware,
];

export default crbMiddlewares;
